import { SessionHelper } from "app/helpers/sessionHelper";
import { BetslipPanelTypes } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import type { Element } from "react";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { $Values } from "utility-types";
type Props = {
  numberOfReports: number;
};
type State = {
  tab: $Values<typeof BetslipPanelTypes>;
};

class OpenBetsHeader extends Component<Props, State> {
  shouldComponentUpdate: (nextProps: any, nextState: any) => boolean = (
    nextProps: any,
    nextState: any
  ) => {
    if (nextProps.numberOfReports !== this.props.numberOfReports) return true;
    return true;
  };
  render: () => Element<"div"> = () => {
    let { numberOfReports } = this.props;

    const reportsLink = SessionHelper.isAsianSessionView()
      ? "/asian/openbets"
      : "/reports";
    const viewingOpenBets = window.location.href.indexOf("openbets") > -1;
    return (
      <div className="manage-bets-layout--open-bets-header">
        <div className="manage-bets-layout__count">
          {`
            ${numberOfReports >= 15 ? 15 : numberOfReports}
            / ${numberOfReports} `}
          <FormattedMessage tagName="span" id="bets-betslip-bets" />
        </div>
        {!viewingOpenBets && !isPublicView() && (
          <Link
            to={reportsLink}
            className="manage-bets-layout__collapse-button"
          >
            <FormattedMessage
              tagName="span"
              id="bets-slip-view-all-open-bets-asian"
            />
          </Link>
        )}
      </div>
    );
  };
}

export default React.memo(OpenBetsHeader);
